import weather_cloud from './svg/weather_cloud.svg';
import weather_cloud_fog from './svg/weather_cloud_fog.svg';
import weather_cloud_rain from './svg/weather_cloud_rain.svg';
import weather_cloud_sleet from './svg/weather_cloud_sleet.svg';
import weather_cloud_snow from './svg/weather_cloud_snow.svg';
import weather_cloud_sun from './svg/weather_cloud_sun.svg';
import weather_cloud_sun_rain from './svg/weather_cloud_sun_rain.svg';
import weather_clouds from './svg/weather_clouds.svg';
import weather_sun from './svg/weather_sun.svg';
import weather_thunderstorm from './svg/weather_thunderstorm.svg';

const svgs = {
  weather_cloud,
  weather_cloud_fog,
  weather_cloud_rain,
  weather_cloud_sleet,
  weather_cloud_snow,
  weather_cloud_sun,
  weather_cloud_sun_rain,
  weather_clouds,
  weather_sun,
  weather_thunderstorm,
};

export type SvgWeatherList = keyof typeof svgs;
export default svgs;
